module.exports = __webpack_public_path__ + "img/indica_stonerstoken.89aebbb.png";